import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserRoutingModule } from './user-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EmployeeAttendanceComponent } from './employee-attendance/employee-attendance.component';
import { EmployeeManagerComponent } from './employee-manager/employee-manager.component';
import { EmployeeSalaryComponent } from './employee-salary-component/employee-salary-component.component';
import { EmployeeTimeshiftComponent } from './employee-timeshift/employee-timeshift.component';
import { PhoneCallComponent } from './phone-call/phone-call.component';
import { PhoneManagerComponent } from './phone-manager/phone-manager.component';
import { PhoneRecordComponent } from './phone-record/phone-record.component';
import { OrderBookingComponent } from './order-booking/order-booking.component';
import { OrderManagerComponent } from './order-manager/order-manager.component';
import { OrderProductionComponent } from './order-production/order-production.component';
import { OrderWarehouseComponent } from './order-warehouse/order-warehouse.component';
import { WarehouseExportComponent } from './warehouse-export/warehouse-export.component';
import { WarehouseImportComponent } from './warehouse-import/warehouse-import.component';
import { WarehouseManagerComponent } from './warehouse-manager/warehouse-manager.component';
import { WarehouseMaterialComponent } from './warehouse-material/warehouse-material.component';
import { WarehouseSupplierComponent } from './warehouse-supplier/warehouse-supplier.component';
import { WarehouseUnitComponent } from './warehouse-unit/warehouse-unit.component';
import { ProductManagerComponent } from './product-manager/product-manager.component';
import { ProductGroupComponent } from './product-group/product-group.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { SharedModule } from '../../shared.module';
import { StoreManagerComponent } from './store-manager/store-manager.component';
import { StoreOrderComponent } from './store-order/store-order.component';
import { StoreInventoryComponent } from './store-inventory/store-inventory.component';
import { EmployeeGroupComponent } from './employee-group/employee-group.component';
import { PhoneContactComponent } from './phone-contact/phone-contact.component';
import { ChatComponent } from './chat/chat.component';
import { UploadModule } from "../../pipes/upload/upload.module";
import { WorkCalendarComponent } from './work-calendar/work-calendar.component';
import { PhoneRecordReportComponent } from './phone-record-report/phone-record-report.component';
import { MultiSelectModule } from '../../pipes/multi-select/multi-select.module';
import { PwaComponent } from './pwa/pwa.component';
import { EmployeeOvertimeComponent } from './employee-overtime/employee-overtime.component';
import { FormulaSalaryComponent } from './formula-salary/formula-salary.component';
import { FormulaTimekeepingComponent } from './formula-timekeeping/formula-timekeeping.component';
import { EmployeeFaceComponent } from './employee-face/employee-face.component';
import { EmployeeRelocationComponent } from './employee-relocation/employee-relocation.component';
import { EmployeeAbsenceComponent } from './employee-absence/employee-absence.component';
import { EmployeeLeaveComponent } from './employee-leave/employee-leave.component';
import { EmployeeStoreComponent } from './employee-store/employee-store.component';
import { EmployeePositionComponent } from './employee-position/employee-position.component';
import { EmployeeSalaryKpiComponent } from './employee-salary-kpi/employee-salary-kpi.component';
import { SelectSearchModule } from '../../pipes/select-search/select-search.module';
import { EmployeeReportComponent } from './employee-report/employee-report.component';
import { EmployeeAllowanceComponent } from './employee-allowance/employee-allowance.component';
import { EmployeeKpiUnitComponent } from './employee-kpi-unit/employee-kpi-unit.component';
import { EmployeeAttendanceReportComponent } from './employee-attendance-report/employee-attendance-report.component';
import { AdminErrorLogComponent } from './admin-error-log/admin-error-log.component';
import { EmployeeTaskComponent } from './employee-task/employee-task.component';
import { EmployeeMoneyPlusComponent } from './employee-money-plus/employee-money-plus.component';
import { MediaSelectModule } from '../../pipes/media-select/media-select.module';
import { MediaManagerComponent } from './media-manager/media-manager.component';
import { EmployeeAllowanceExtraComponent } from './employee-allowance-extra/employee-allowance-extra.component';
import { EmployeePayslipComponent } from './employee-payslip/employee-payslip.component';
import { VehicleLocationComponent } from './vehicle-location/vehicle-location.component';
import { VehicleRouterComponent } from './vehicle-router/vehicle-router.component';
import { VehicleComponent } from './vehicle/vehicle.component';
import { AddComponent } from './employee-salary-component/add/add.component';
import { TableSalaryDayComponent } from './formula-salary/table-salary-day/table-salary-day.component';
import { KpiAddComponent } from './employee-salary-kpi/kpi-add/kpi-add.component';
import { TableSalaryHourComponent } from './formula-salary/table-salary-hour/table-salary-hour.component';
import { TableSalaryKpiComponent } from './formula-salary/table-salary-kpi/table-salary-kpi.component';
import { LocalShippingComponent } from './localshipping/localshipping.component';
import { EmployeeWorkReviewComponent } from './employee-work-review/employee-work-review.component';
import { EmployeeSalaryAdvanceComponent } from './employee-salary-advance/employee-salary-advance.component';
import { EmployeePassbookComponent } from './employee-passbook/employee-passbook.component';
import { ProductRequestComponent } from './product-request/product-request.component';




@NgModule({
  declarations: [
    AdminErrorLogComponent,
    EmployeeAttendanceComponent,
    EmployeeManagerComponent,
    EmployeeSalaryComponent,
    EmployeeTimeshiftComponent,
    PhoneCallComponent,
    PhoneManagerComponent,
    PhoneRecordComponent,
    OrderBookingComponent,
    OrderManagerComponent,
    OrderProductionComponent,
    OrderWarehouseComponent,
    WarehouseExportComponent,
    WarehouseImportComponent,
    WarehouseManagerComponent,
    WarehouseMaterialComponent,
    WarehouseSupplierComponent,
    WarehouseUnitComponent,
    ProductManagerComponent,
    ProductGroupComponent,
    UserProfileComponent,
    StoreManagerComponent,
    StoreOrderComponent,
    StoreInventoryComponent,
    EmployeeGroupComponent,
    PhoneContactComponent,
    ChatComponent,
    WorkCalendarComponent,
    PhoneRecordReportComponent,
    PwaComponent,
    EmployeeOvertimeComponent,
    FormulaSalaryComponent,
    FormulaTimekeepingComponent,
    EmployeeFaceComponent,
    EmployeeRelocationComponent,
    EmployeeLeaveComponent,
    EmployeeAbsenceComponent,
    EmployeeStoreComponent,
    EmployeePositionComponent,
    EmployeeSalaryKpiComponent,
    EmployeeReportComponent,
    EmployeeAllowanceComponent,
    EmployeeKpiUnitComponent,
    EmployeeAttendanceReportComponent,
    EmployeeTaskComponent,
    EmployeeMoneyPlusComponent,
    MediaManagerComponent,
    EmployeeAllowanceExtraComponent,
    EmployeePayslipComponent,
    VehicleLocationComponent,
    VehicleRouterComponent,
    VehicleComponent,
    LocalShippingComponent,
    AddComponent,
    KpiAddComponent,
    TableSalaryDayComponent,
    TableSalaryHourComponent,
    TableSalaryKpiComponent,
    EmployeeWorkReviewComponent,
    EmployeeSalaryAdvanceComponent,
    EmployeePassbookComponent,
    ProductRequestComponent,
  ],
  imports: [
    SharedModule,
    CommonModule,
    UserRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    UploadModule,
    MultiSelectModule,
    MediaSelectModule,
    SelectSearchModule
  ],
  //customschema
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UserModule { }
